module.exports = __webpack_public_path__ + "static/media/minus-icon.62a9b044.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/minus-icon.svg
// module id = 2880
// module chunks = 0